module.exports = __webpack_public_path__ + "assets/ff82688a043efa7132e6431f4869b5f4.png";